import { AvatarTabs } from '@/pages/avatar';
import { useAvatarListPageContext } from '@/pages/avatar/ListPage/contex';
import styled from '@emotion/styled';

const FiltersContainer = styled.div`
    margin-bottom: 24px;
`;

export const Filters = () => {
    const { filter, setFilter } = useAvatarListPageContext();

    return (
        <FiltersContainer>
            <AvatarTabs filter={filter} setFilter={setFilter} />
        </FiltersContainer>
    );
};
